import React, {Component} from 'react';
import {NavLink, withRouter} from "react-router-dom";
import {withAlert} from 'react-alert';
import {loadCategories} from "../common/Common";

import Interior from '../assets/images/Interior.jpg';
import Exterior from '../assets/images/Exterior.jpg';
import Carburetors from '../assets/images/Carburetors.jpg';
import Exhaust from '../assets/images/Exhaust.jpg';
import Brakes from '../assets/images/Brakes.jpg';
import Engine from '../assets/images/Engine.jpg';
import Electric from '../assets/images/Electric.jpg';
import Ignition from '../assets/images/Ignition.jpg';
import Lighting from '../assets/images/Lighting.jpg';
import Loading from "./Loading";

class CategoryComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            categories: [],
            images: {
                Interior: Interior,
                Exterior: Exterior,
                Carburetors: Carburetors,
                Exhaust: Exhaust,
                Brakes: Brakes,
                Engine: Engine,
                Electric: Electric,
                Ignition: Ignition,
                Lighting: Lighting
            },
            loading: true
        };
    }

    componentDidMount() {
        if (this.props.categories) {
            this.setState({categories: this.props.categories, loading: false});
        } else {
            loadCategories().then(data => {
                this.setState({categories: this.props.home ? data.splice(0, 3) : data, loading: false});
            }).catch(() => null);
        }
    }

    render() {
        return (
            this.state.loading ?
                <Loading/>
                : <div>
                    {!this.props.categories ?
                        [
                            <h1 className="heading" key="heading">Categories</h1>,
                            <hr key="hr"/>
                        ] : null
                    }
                    {this.getCategoryBody()}
                </div>
        );
    }

    getCategoryBody = () => {
        let firstColumn = [];
        let secondColumn = [];
        let thirdColumn = [];
        this.state.categories.forEach((category, index) => {
            if ((index + 1) % 3 === 0) {
                thirdColumn.push(this.getCategoryCode(category, index))
            } else if ((index + 1) % 2 === 0) {
                secondColumn.push(this.getCategoryCode(category, index))
            } else {
                firstColumn.push(this.getCategoryCode(category, index))
            }
        });

        return (
            <div className="d-flex bd-highlight w-100">
                <div className="p-2 flex-fill bd-highlight">
                    {firstColumn}
                </div>
                <div className="p-2 flex-fill bd-highlight">
                    {secondColumn}
                </div>
                <div className="p-2 flex-fill bd-highlight">
                    {thirdColumn}
                </div>
            </div>
        );
    };

    getCategoryCode = (category, index) => {
        return (
            <div key={index} className="category-item">
                <NavLink className="nav-link" to={"/category/" + category.name}>
                    <img src={this.state.images[category.name]} alt={category.name}/>
                    <div className="category-item-name">{category.name}</div>
                </NavLink>
            </div>
        );
    };
}

export default withAlert()(withRouter(CategoryComponent));